/**
 * Public marketing-site facts. Everything a lawyer, a designer, or a launch
 * checklist might need to change lives here rather than inside a page.
 */

export const SITE = {
  name: 'Shoutt',
  tagline: 'Rent what you need. From students on your own campus.',
  intro:
    'Shoutt is a campus-only rental marketplace. Verified college students lend what they already own, borrow what they need for a day or a week, and settle up with a deposit that both sides can see.',
  url: 'https://shoutt.live',
} as const;

export const CONTACT = {
  email: 'hello@shoutt.live',
  grievanceEmail: 'hello@shoutt.live',
  /** Play's CSAE point of contact, and the address declared in Play Console. Currently
   *  the developer account address; point it at a dedicated monitored alias if one is
   *  ever created — the published standards page reads this, so it updates with it. */
  childSafetyEmail: 'founders@shoutt.live',
} as const;

/**
 * Store listings are not live yet, so the CTAs render as "coming soon" badges.
 * Set a URL here and the badge becomes a real link — no other file changes.
 */
export const STORE_LINKS: { ios: string | null; android: string | null } = {
  ios: null,
  android: null,
};

/** Registered entity behind the Shoutt brand. Rendered verbatim in the legal pages. */
export const LEGAL_ENTITY = {
  name: 'Pear Circle Private Limited',
  address:
    'BL-102, Lotus Apartment, Swastik Soc., Sanala Road, Morbi MDG, Morbi, Rajkot – 363641, Gujarat',
  jurisdiction: 'Ahmedabad, Gujarat',
  grievanceOfficer: 'Ritesh Phophalia',
  grievanceOfficerDesignation: 'Founder',
} as const;

/** Shown as "Last updated" on the legal pages. */
export const LEGAL_LAST_UPDATED = '24 August 2026';
